import type { Context } from '@opentelemetry/api';
import type { ReadableSpan, Span, SpanProcessor } from '@opentelemetry/sdk-trace-base';

import {
  ACCOUNT_ID_KEY,
  PAGE_PATHNAME_KEY,
  PAGE_REFERER_KEY,
  PARTNER_ID_KEY,
  USER_ID_KEY,
} from './userContextPropagator';

/**
 * Reads user/account/partner IDs from the span context and sets them as span attributes.
 * UserContextPropagator is responsible for populating the span context with these IDs.
 */
class UserContextSpanProcessor implements SpanProcessor {
  onStart(span: Span, parentContext: Context): void {
    const accountId = parentContext.getValue(ACCOUNT_ID_KEY);
    const userId = parentContext.getValue(USER_ID_KEY);
    const partnerId = parentContext.getValue(PARTNER_ID_KEY);

    const pathname = parentContext.getValue(PAGE_PATHNAME_KEY);
    const referer = parentContext.getValue(PAGE_REFERER_KEY);

    if (typeof accountId === 'string') span.setAttribute('accountId', accountId);
    if (typeof userId === 'string') span.setAttribute('userId', userId);
    if (typeof partnerId === 'string') span.setAttribute('partnerId', partnerId);
    if (typeof pathname === 'string') span.setAttribute('page.pathname', pathname);
    if (typeof referer === 'string') span.setAttribute('page.referer', referer);
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function -- required by SpanProcessor interface
  onEnd(_span: ReadableSpan): void {}
  forceFlush(): Promise<void> {
    return Promise.resolve();
  }
  shutdown(): Promise<void> {
    return Promise.resolve();
  }
}

const userContextSpanProcessor = new UserContextSpanProcessor();

export { userContextSpanProcessor };
